const FEED_TYPES = {
  COLLABORATION: 'COLLABORATION',
  CAMPAIGN: 'CAMPAIGN',
  ORGANISATION: 'ORGANISATION',
  ALL: 'ALL',
};

const FEED_VIEW_MODES = {
  CARDS: 'CARDS',
  TABLE: 'TABLE',
};


module.exports = {
  FEED_TYPES,
  FEED_VIEW_MODES,
};



/** WEBPACK FOOTER **
 ** ./src/containers/event-feed/static.js
 **/